import { render, staticRenderFns } from "./CompanyFulfillmentsOmsAdd.vue?vue&type=template&id=2b7e46c2&scoped=true&"
import script from "./CompanyFulfillmentsOmsAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyFulfillmentsOmsAdd.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFulfillmentsOmsAdd.vue?vue&type=style&index=0&id=2b7e46c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e46c2",
  null
  
)

export default component.exports